import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Intercom } from '@supy-io/ngx-intercom';
import { BsChatService } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'brightside-web-credit-setup-error',
    templateUrl: './credit-setup-error.component.html',
    standalone: false
})
export class CreditSetupErrorComponent {
  constructor(private _intercom: Intercom, private _router: Router, private _bsChatService: BsChatService) {}

  handleClick(): void {
    this._bsChatService.showChat();
  }

  routeUserOnBack(): void {
    this._router.navigate(['home']);
  }
}
